import { AppBundle } from 'api/optimalprint-sdk.d';
import { PricesToFetch } from 'store/price/types';

const collectPricesFromMoreArePrints = (
  designs: AppBundle.Api.Response.Category.V3.SearchDesignsV3Response.Design[],
) => {
  const result: PricesToFetch = {};
  designs.forEach((design) => {
    const categoryId = design.category.id;
    const { productId } = design;
    if (!result[categoryId]) {
      result[categoryId] = {
        categoryId,
        productIds: [],
        encryptedDesignId: design.encryptedId,
      };
    }
    result[categoryId].productIds.push(productId);
  });

  return result;
};

export default collectPricesFromMoreArePrints;
